import React, { Fragment, useState } from 'react';
import { Typography, Box, Container, Popover, TextField, IconButton, Tooltip, Button } from '@material-ui/core';

import DeleteIcon from '@material-ui/icons/Delete';

import { Email } from 'react-frontend-utils' 

/**
 * This component is a popover that allows the user to update the Patron information for a Booking
 * 
 * The user can supply the following props:
 * 
 * isOpen (boolean): True if the popover is open, false otherwise
 * patron (Patron): The Patron object to update
 * okCallback (function): A callback function that is called when the clicks Ok, the new contact name, email, phone, enableSMS and patron names are passed as arguments
 * cancelCallback (function): A callback function that is called when the user clicks the cancel button
 */
export function EditPatronPopover(props) {

    const maxWidth = window.innerWidth * 0.7
    const [contactName, setContactName] = useState(props.patron.contactName);
    const [email, setEmail] = useState(props.patron.patronEmail);
    const [phone, setPhone] = useState(props.patron.patronPhone);
    const [enableSms, setEnableSms] = useState(props.patron.enableSms);
    const [emailValid, setEmailValid] = useState(email ? Email.validateEmail(email) : false);

    const onContactNameChange = (event) => {
        setContactName(event.target.value);
    }

    const onEmailChange = (event) => {
        const email = event.target.value;
        setEmailValid(Email.validateEmail(email));
        setEmail(email);
    }

    const onPhoneChange = (event) => {
        setPhone(event.target.value);
    }

    const onSmsChange = (event) => {
        setEnableSms(event.target.checked);
    }

    const [patronNames, setPatronNames] = useState(props.patron.patronNames ? props.patron.patronNames : []);

    const onPatronNameChange = (index, event) => {
        const newPatronNames = [...patronNames];
        newPatronNames[index] = event.target.value;
        setPatronNames(newPatronNames);
    };

    const addPatronName = () => {
        const newPatronNames = [...patronNames, ''];
        setPatronNames(newPatronNames);
    };

    const deletePatronName = (index) => {
        const newPatronNames = patronNames.filter((_, i) => i !== index);
        setPatronNames(newPatronNames);
    };


    const cancel = () => {
        props.cancelCallback();
    }

    const ok = () => {
        props.okCallback(contactName, email, phone, enableSms, patronNames);
    }

    const patronNamesValid = patronNames.length > 0 && patronNames[0].trim().length > 0;

    const canApplyChanges = emailValid && patronNamesValid;

    return (
        <Popover open={true}
            anchorReference="anchorPosition"
            anchorPosition={{left: window.innerWidth/2, top: window.innerHeight/2}}
            transformOrigin={{vertical: 'center', horizontal: 'center'}}>
                    
            <Box style={{margin: 20, width: maxWidth}}>
                <Typography variant="subtitle1" style={{fontWeight: 'bold', marginBottom: 20}}>Edit Patron Information</Typography>  

                {props.patron ?
                    <Fragment>
                        <Typography variant="body2" style={{fontStyle: 'italic', fontWeight: 'bold', marginBottom: 10}}>Contact Information</Typography>
                                                   
                        <TextField style={{marginBottom: 20}} label="Contact Name *" size='small' variant="outlined" fullWidth value={contactName} onChange={onContactNameChange} InputLabelProps={{ shrink: true}}/>
                        
                        <TextField style={{marginBottom: 2}} label="Email Contact *" size='small' variant="outlined" fullWidth value={email} onChange={onEmailChange} InputLabelProps={{ shrink: true}}/>
                        {emailValid ? 
                            <div style={{marginBottom: 20, height: 12}}></div>
                            : 
                            <div style={{color: 'red', fontSize: 12, fontStyle: 'italic', marginBottom: 20, marginRight: 20, height: 12, textAlign: 'right'}}>{!email ? "Email address required" : "Invalid email address"}</div>
                        }

                        <div style={{display: 'flex', alignItems: 'center', marginBottom: 20}}>
                            <TextField style={{marginRight: 15, flexGrow: 1}} label="Phone" size='small' variant="outlined" value={phone} onChange={onPhoneChange} InputLabelProps={{ shrink: true}}/>
                            {/*<Checkbox color='primary' disabled={true} checked={enableSms} onChange={onSmsChange}/>
                            <Typography variant="body2" style={{color: 'gray'}}>Enable SMS Text Messaging (Coming soon)</Typography>*/}
                        </div>

                        <Typography variant="body2" style={{fontStyle: 'italic', fontWeight: 'bold', marginTop: 20}}>Who is Attending?</Typography>

                        {patronNames.length === 0 ?   
                            <div style={{color: 'red', textAlign: 'center', fontSize: 12, fontStyle: 'italic', marginBottom: 20, height: 12}}>At least one Patron required</div>
                            :
                            null
                        }
                        
                        <div style={{display: 'flex', justifyContent: 'center', marginTop: 20, marginBottom: 20}}>
                            <Button onClick={addPatronName} style={{color: patronNames.length === 0 ? 'green' : 'blue'}} variant="outlined">
                                {patronNames.length === 0 ? "Add Patron" : "Add Another Patron"}
                            </Button>
                        </div>

                        {patronNames.map((name, index) => (
                                <Box key={index} display="flex" alignItems="center" mb={2}>
                                    <TextField
                                        label={"Patron " + (index + 1) + " Name"}
                                        size="small"
                                        variant="outlined"
                                        fullWidth
                                        value={name}
                                        onChange={(event) => onPatronNameChange(index, event)}
                                        InputLabelProps={{ shrink: true }}
                                    />
                                    <Tooltip title="Delete Patron" placement="top">
                                        <IconButton edge="end" onClick={() => deletePatronName(index)}>
                                            <DeleteIcon />
                                        </IconButton>
                                    </Tooltip>
                                    
                                </Box>
                            ))
                        }

                    </Fragment>
                    : null
                }

                <Container style={{display: 'flex', justifyContent: 'center', marginTop: 20, gap: 20}}>    
                    <Button disabled={!canApplyChanges} onClick={ok} style={{color: canApplyChanges ? 'green' : 'gray'}} variant="outlined">Apply Changes</Button>
                    <Button onClick={cancel} variant="outlined">Cancel</Button>
                </Container>
            </Box>

        </Popover>
    );
    
}